<script>
/* eslint-disable */
import {consultaLeilao, relacionaItensLeilao} from "@/domain/integra/services/grupo-porto"
import {ErpSelect} from 'uloc-vue-plugin-erp'
import {UCheckbox, UTable, UTd, UTh, UTr} from "uloc-vue"
import {list} from "@/domain/leiloes/services"
import ERow from '@/components/layout/components/Row'
import ECol from '@/components/layout/components/Col'

let listStorage = [
  {label: 'Placa', name: 'placa', active: true, sortable: true, ordering: 1},
  {label: 'Chassi', name: 'chassi', active: true, sortable: true, ordering: 1},
  {label: 'Mínimo', name: 'valorMinimo', active: true, sortable: true, ordering: 1},
  {label: 'Último Leilão', name: 'dataLeilao', active: true, sortable: true, ordering: 1},
  {label: 'Último Lote', name: 'lote', active: true, sortable: true, ordering: 1},
  {label: 'SIS', name: 'sis', active: true, sortable: true, ordering: 1},
  {label: 'Sinistro', name: 'sinistro', active: true, sortable: true, ordering: 1},
  {label: 'ID Bem', name: 'bem', active: true, sortable: true, ordering: 1},
  {label: 'Leilão Ativo', name: 'leilao', active: true, sortable: true, ordering: 1},
]

let filters = {
  pesquisa: null
}

export default {
  name: 'WSGrupoPortoConsultaLeilao',
  inject: ['page'],
  mixins: [],
  components: {
    ErpSelect,
    UTable,
    UTh,
    UTr,
    UTd,
    UCheckbox,
    ECol,
    ERow
  },
  data() {
    return {
      listStorage: listStorage,
      table: {
        busca: '',
        serverData: [],
        serverPagination: {
          page: 1,
          rowsNumber: 1, // specifying this determines pagination is server-side
          rowsPerPage: 500
        },
        columns: listStorage.map(o => {
          return {
            ...o,
            field: o.name,
            required: o.required || null,
            align: 'left'
          }
        }).concat([
          {
            name: 'options',
            required: true,
            label: '',
            field: 'options',
            sortable: false
          }
        ]),
        filter: '',
        filters: JSON.parse(JSON.stringify(filters)),
        selected: [],
        loading: false
      },
      loading: false,
      seletor: null,
      resultado: null,
      loadingLeiloes: false,
      leilao: null,
      asyncdata: []
    }
  },
  computed: {
    visibledColumns() {
      return this.listStorage.filter(item => {
        return item.active
      }).map(item => item.name)
    },
    filteredServerData() {
      let data = this.table.serverData.slice()
      let busca = this.table.filters.pesquisa
      if (busca && String(busca).length > 0) {
        console.log(busca)
        data = data.filter(lt => {
          return String(lt.Placa).toLowerCase().indexOf(busca) > -1 ||
              String(lt.Chassi).toLowerCase().indexOf(busca) > -1
        })
      }
      return data
    }
  },
  mounted() {
    this.page.setActive('consultaLeilao')
    const container = document.querySelector('.u-erp-layout-container')
    !container.classList.contains('app-globalconfig') && container.classList.add('app-globalconfig')
    this.loadLeiloesAtivos()
  },
  beforeDestroy() {
    document.querySelector('.u-erp-layout-container').classList.remove('app-globalconfig')
  },
  methods: {
    request() {
    },
    consultar() {
      this.table.loading = true
      consultaLeilao(this.seletor)
          .then(({data}) => {
            this.table.loading = false
            this.table.serverData = data.resposta.Leiloes
            this.table.serverPagination.rowsNumber = Array.isArray(data.resposta.Leiloes) ? data.resposta.Leiloes.length : 0
            this.loading = false
            this.resultado = data
            console.log(data)
          })
          .catch(error => {
            this.table.loading = false
            this.alertApiError(error)
          })
    },
    infoBem(row) {
      let comitente = row.bem.comitente
      let comitenteNome = comitente.nome
      comitenteNome = comitenteNome.split(' ')
      comitenteNome = comitenteNome.shift()
      return `${row.bem.id}/${row.bem.comitente.id}/${comitenteNome}`
    },
    loadLeiloesAtivos() {
      this.loading = true
      console.log('Loading leiloes')
      list(100, 1, '&status=0,1,2,3,4&sortBy=dataProximoLeilao&descending=true') // TODO: Criar filtro de ativo na requisição
          .then((response) => {
            this.loading = false
            if (!Array.isArray(response.data.result)) {
              return
            }
            let list = response.data.result.map((obj) => {
              return {
                ...obj,
                label: obj.codigo + ' ' + this.$options.filters.formatDate(obj.dataProximoLeilao.date),
                value: obj.id
              }
            })
            // !this.multiple && !this.required && list.unshift({label: this.placeholder || 'Selecione', value: null})
            this.asyncdata = list
          })
          .catch((error) => {
            this.loading = false

          })
    },
    relacionarLeilao() {
      if (!this.leilao) {
        this.$uloc.dialog({
          title: 'Necessário selecionar um leilão',
          message: 'Selecione um leilão para relacionar o(s) bem(ns)',
          color: 'negative'
        })
        return
      }
      const leilao = this.leilao
      const itens = this.table.selected
      console.log('Inserindo itens no leilão', itens, leilao)
      this.$uloc.loading.show()
      relacionaItensLeilao(leilao, itens)
          .then(({data}) => {
            console.log(data)
            this.$uloc.loading.hide()
            this.consultar()
            if (Array.isArray(data.errors) && data.errors.length) {
              this.$uloc.dialog({
                title: 'Importação concluída com erros',
                message: 'Loteamento realizado com sucesso, porém, alguns erros foram retornados: ' + data.errors.join(', ')
              })
            } else{
              this.$uloc.dialog({
                title: 'Importação concluída',
                message: 'Loteamento realizado com sucesso',
                color: 'positive'
              })
            }
          })
          .catch((error) => {
            this.$uloc.loading.hide()
            this.alertApiError(error)
          })
    }
  }
}
</script>

<template>
  <div class="flex col-grow no-wrap globalconfigs-container">
    <transition name="slide" appear>
      <div class="transition-generic w-full">
        <div class="global-config-container">
          <div class="m-t m-b-lg">
            <!--            <h2 class="i-title">Consulta de veículos disponíveis para leilão</h2>
                        <p class="m-b-xxl">Integração com o Grupo Porto</p>-->
            <h2 class="i-title">Consulta de veículos aptos para leilão</h2>
            <div class="m-t-md">
              Selecione qual serviço você deseja consumir:<br>
              <erp-select class="m-t-sm" size="2" placeholder="Selecione"
                          :options="[{label: 'Azul', value: 'azul'},{label: 'Porto', value: 'porto'}]"
                          v-model="seletor"/>
              <e-btn @click="consultar" class="m-t-xs" label="Consultar"/>
            </div>

            <div class="m-t-lg">
              <div v-if="loading">
                <i class="fa fa-spin fa-spinner"></i> Aguarde enquanto consultamos o webservice do comitente.
              </div>
            </div>
          </div>

          <div class="erp-list">
            <u-table
                ref="table"
                color="primary"
                :data="filteredServerData"
                :columns="table.columns"
                :visible-columns="visibledColumns"
                :filter="table.busca"
                row-key="id"
                :pagination.sync="table.serverPagination"
                @request="request"
                selection="multiple"
                :selected.sync="table.selected"
                :loading="table.loading"
                class="erp-table"
                :rows-per-page-options="[100, 300, 500]"
            >
              <!--<template slot="top-right" slot-scope="props">
              </template>-->
              <u-tr slot="header" slot-scope="props">
                <u-th auto-width>
                  <u-checkbox
                      v-model="props.selected"
                      :indeterminate="props.partialSelected"
                      size="sm"
                  />
                </u-th>
                <u-th v-for="col in props.cols" :key="col.name" :props="props">
                  {{ col.label }}
                </u-th>
              </u-tr>

              <u-tr class="cursor-pointer" slot="body" slot-scope="props"
                    :props="props">
                <u-td auto-width>
                  <u-checkbox color="primary" v-model="props.selected" size="xs"/>
                </u-td>
                <u-td key="placa" :props="props">
                  {{ props.row.Placa }}
                </u-td>
                <u-td key="chassi" :props="props">
                  {{ props.row.Chassi }}
                </u-td>
                <u-td key="valorMinimo" :props="props">
                  R$ {{ props.row.ValorMinimo|moeda }}
                </u-td>
                <u-td key="dataLeilao" :props="props">
                  {{ props.row.DataLeilao }}
                </u-td>
                <u-td key="lote" :props="props">
                  {{ props.row.NumeroLote }}
                </u-td>
                <u-td key="sis" :props="props">
                  {{ props.row.SIS }}
                </u-td>
                <u-td key="sinistro" :props="props">
                  {{ props.row.Sinistro }}
                </u-td>
                <u-td key="bem" :props="props">
                  <div v-if="props.row.bem">
                    {{ infoBem(props.row) }}
                  </div>
                  <span v-else>-</span>
                </u-td>
                <u-td key="leilao" :props="props">
                  <div v-if="props.row.leilao">
                    {{props.row.leilao.id}} - {{props.row.leilao.codigo}}
                  </div>
                  <span v-else>-</span>
                </u-td>

                <u-td class="text-center" key="options" :props="props">
                </u-td>
              </u-tr>
            </u-table>

            <div v-if="table.selected.length > 0">
              <e-row>
                <e-col class="flex items-center m-r-md">
                  <erp-select
                      :loading="loadingLeiloes"
                      placeholder="Selecione o leilão"
                      :options="asyncdata"
                      v-model="leilao"
                      size="2"
                      class="md"
                  ></erp-select>
                </e-col>
                <e-col>
                  <u-btn @click="relacionarLeilao" no-caps push color="primary" icon="plus" icon-type="fa"
                         label="Relacionar bens selecionados ao leilão"/>
                </e-col>
              </e-row>

            </div>
          </div>


        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="stylus" src="../assets/default.styl"></style>
